var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(_vm._s(_vm.$t('Phone No.')))]), _c('div', {
    staticClass: "text-[16px] text-right"
  }, [_c('a', {
    staticClass: "link !text-[#134B96] !font-semibold",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('switched');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Login with member no.')))])])]), _c('div', {
    staticClass: "flex items-center justify-center w-full"
  }, [_c('div', {
    staticClass: "w-[30%] xl:w-[25%] mr-[1rem]"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "phone_area_code"
    }
  }, [_c('phone-area-code-select', {
    model: {
      value: _vm.form.phone_area_code,
      callback: function ($$v) {
        _vm.$set(_vm.form, "phone_area_code", $$v);
      },
      expression: "form.phone_area_code"
    }
  })], 1)], 1), _c('div', {
    staticClass: "grow"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.form.phone,
      callback: function ($$v) {
        _vm.$set(_vm.form, "phone", _vm._n($$v));
      },
      expression: "form.phone"
    }
  })], 1)], 1)]), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('Password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "show-password": ""
    },
    model: {
      value: _vm.form.password,
      callback: function ($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    staticClass: "green-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.submitForm('form');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Login')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };